const compatModules = {};import * as Mod1 from "./discourse/components/waze-category-box";
compatModules["discourse/components/waze-category-box"] = Mod1;

export * as discourse$components$waze__category__box$$__module from "./discourse/components/waze-category-box";
export {
default as discourse$components$waze__category__box$$default
} from "./discourse/components/waze-category-box";
import * as Mod2 from "./discourse/components/waze-semi-category-dialog-content";
compatModules["discourse/components/waze-semi-category-dialog-content"] = Mod2;

export * as discourse$components$waze__semi__category__dialog__content$$__module from "./discourse/components/waze-semi-category-dialog-content";
export {
default as discourse$components$waze__semi__category__dialog__content$$default
} from "./discourse/components/waze-semi-category-dialog-content";
import * as Mod3 from "./discourse/connectors/category-custom-settings/waze-semi-category-settings.gjs";
compatModules["discourse/connectors/category-custom-settings/waze-semi-category-settings"] = Mod3;

export * as discourse$connectors$category__custom__settings$waze__semi__category__settings$$__module from "./discourse/connectors/category-custom-settings/waze-semi-category-settings.gjs";
export {
default as discourse$connectors$category__custom__settings$waze__semi__category__settings$$default
} from "./discourse/connectors/category-custom-settings/waze-semi-category-settings.gjs";
import * as Mod4 from "./discourse/connectors/discovery-above/waze-semi-categories.gjs";
compatModules["discourse/connectors/discovery-above/waze-semi-categories"] = Mod4;

export * as discourse$connectors$discovery__above$waze__semi__categories$$__module from "./discourse/connectors/discovery-above/waze-semi-categories.gjs";
export {
default as discourse$connectors$discovery__above$waze__semi__categories$$default
} from "./discourse/connectors/discovery-above/waze-semi-categories.gjs";
import * as Mod5 from "./discourse/lib/fuse";
compatModules["discourse/lib/fuse"] = Mod5;

export * as discourse$lib$fuse$$__module from "./discourse/lib/fuse";
export {
FuseJs as discourse$lib$fuse$$FuseJs
} from "./discourse/lib/fuse";
import * as Mod6 from "./discourse/lib/waze-semi-categories";
compatModules["discourse/lib/waze-semi-categories"] = Mod6;

export * as discourse$lib$waze__semi__categories$$__module from "./discourse/lib/waze-semi-categories";
export {
WAZE_SEMI_CATEGORIES as discourse$lib$waze__semi__categories$$WAZE_SEMI_CATEGORIES,
WAZE_SEMI_CATEGORY_OTHER_ID as discourse$lib$waze__semi__categories$$WAZE_SEMI_CATEGORY_OTHER_ID
} from "./discourse/lib/waze-semi-categories";
export default compatModules;
